function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.937 2.188L13.312.813a1.447 1.447 0 011.063-.438c.417 0 .77.146 1.062.438l12.125 12.125c.292.291.438.645.438 1.062 0 .417-.146.77-.438 1.063L15.437 27.187a1.447 1.447 0 01-1.062.438c-.417 0-.77-.146-1.063-.438l-1.375-1.375c-.333-.291-.49-.645-.468-1.062.02-.417.177-.77.468-1.062l7.5-7.188H1.5c-.417 0-.77-.146-1.063-.437A1.447 1.447 0 010 15v-2c0-.417.146-.77.437-1.062A1.447 1.447 0 011.5 11.5h17.937l-7.5-7.187a1.563 1.563 0 01-.468-1.063c-.021-.417.135-.77.468-1.062z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.9bd7e79f.svg";
export { ForwardRef as ReactComponent };